import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Form, Spinner } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import ServiceTechnicianForm from './ServiceTechnicianForm'

import { storeServiceTechnician } from '../services'
import { handleError } from '../../../helpers'

export default function NewServiceTechnicianModal({ visible, onClose, reload, serviceId }) {
	const [loading, setLoading] = useState(false)
	const { handleSubmit, register, formState: { errors }, setValue } = useForm({
		defaultValues: { service_id: serviceId }
	})

	const onSubmit = values => {
		setLoading(true)
		storeServiceTechnician(values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Asociar técnico al servicio</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<ServiceTechnicianForm 
							register={register}
							errors={errors}
							setValue={setValue}
						/>
						<Button color='primary' type="submit" disabled={loading}>
							{ loading && <Spinner animation='border' size="sm" className='mr-1' /> }
							Asociar Técnico
						</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}